import React, { useRef, useEffect } from 'react';
import { RichText,mediaApi } from '@sitecore-jss/sitecore-jss-react';
import { useHistory } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { handleAnchorOffset, handleAnchorOffsetUrlHash } from '../../ts/handleAnchorOffset'

const RoutableRichText = (props) => {
  const history = useHistory();
  const richTextRef = useRef();
  const { pathname } = useLocation();

  const routeHandler = (event) => {
    event.preventDefault();
    let anchor = event.target.closest('a');
    if(anchor !== null){
      history.push(anchor.pathname + anchor.search);
    }
  };

  useEffect(() => {
    if (!richTextRef.current) return;

    const hasText = props.field && props.field.value;
    const isEditing = props.editable && props.field.editable;
  
    if (hasText && !isEditing) {
      // selects all links that start with '/' - this logic may be inappropriate for some advanced uses
      const internalLinks = richTextRef.current.querySelectorAll('a[href^="/"]');
      internalLinks.forEach((link) => {
        // the component can be updated multiple times during its lifespan,
        // and we don't want to bind the same event handler several times so unbind first
        link.removeEventListener('click', routeHandler, false);
        link.addEventListener('click', routeHandler, false);
      });
    }
  },[pathname]);

  useEffect(() => {
    if (!richTextRef.current) return;

    const hasText = props.field && props.field.value;
    const isEditing = props.editable && props.field.editable;

    if(hasText && !isEditing) {
      handleAnchorOffset(richTextRef.current, history);
      //trigger anchor offset on popstate event
      window.addEventListener('popstate', handleAnchorOffsetUrlHash);
      //offset anchor on first load.
      handleAnchorOffsetUrlHash();
      //remove popstate event on dispose 
      return () => window.removeEventListener('popstate', handleAnchorOffsetUrlHash);
    }
  },[pathname]);

  
  useEffect(() => {
    if (!richTextRef.current) return;
    const hasText = props.field && props.field.value;
    const isEditing = props.editable && props.field.editable;
  
    if (hasText && !isEditing) {
      // selects all links that start with '/' - this logic may be inappropriate for some advanced uses
      const images = richTextRef.current.querySelectorAll('img[src*="-/media/"]');
  
      images.forEach((image) => {
        image.src = mediaApi.updateImageUrl(image.src);
      });
    }
  });

  // strip the 'staticContext' prop from withRouter() 
  // to avoid confusing React before we pass it down
  const { className, ...newProps } = props;

  return <div className={className} ref={richTextRef}>
    <RichText {...newProps} />
  </div>;
};

//RoutableRichText = withRouter(RoutableRichText);

export { RoutableRichText };